<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col cols="12" class="pr-0 pl-0">
          <span v-if="contactType === 1" class="h6">
            <i class="far fa-user-friends fa-lg mr-2"></i>{{ $t('views.timetable.dashboard.upcomingMeetings') }}
          </span>
          <span v-else-if="contactType === 2" class="h6">
            <i class="far fa-phone fa-lg mr-2"></i>{{ $t('views.timetable.dashboard.upcomingPhones') }}
          </span>
          <div class="float-right" v-if="canAddRelations">
            <button v-if="contactType === 1" type='button' class="btn btn-info btn-circle btn-sm mt-0 mb-2 ml-1" v-b-tooltip.hover :title="$t('buttons.addRelationNote')" @click="showCreateModal(1)">
              <i class="fa fa-plus"></i>
            </button>
            <button v-if="contactType === 2" type='button' class="btn btn-info btn-circle btn-sm mt-0 mb-2 ml-1" v-b-tooltip.hover :title="$t('buttons.addPhoneNote')" @click="showCreateModal(2)">
              <i class="fa fa-plus"></i>
            </button>
          </div>
          <div v-if="items.length > 0">
            <table class="table table-sm table-striped table-hover">
              <tr>
                <th style="width: 45%">{{$t('views.excmrelation.list.name')}}</th>
                <th style="width: 30%">{{$t('views.excmrelation.list.dateFrom')}}</th>
                <th>ID</th>
                <th style="width: 25%"> </th>
              </tr>
              <tbody>
              <tr
                v-for="item in items"
                :key="item['@id']">
                <td>
                  {{ item['title'] }}
                </td>
                <td>
                  {{ item['dateFrom'] }}
                </td>
                <td>
                  <router-link v-if="item && item.idCase && !($route.params.id === item.idCase)" :to="{name: 'EXCMCaseShow', params: { id: item.idCase }}">
                    {{ getIdLink(item.idCase) }}
                  </router-link>
                  <div v-else-if="item.idCase">
                    {{ getIdLink(item.idCase) }}
                  </div>
                </td>
                <td>
                  <div v-if="canShowRelation" class="float-right">
                    <button class="btn btn-link fa fa-search fa-lg" v-b-tooltip.hover :title="$t('buttons.show')" @click="showModal(item['@id'])"></button>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <b-card-body v-else>{{ $t('views.excmrelation.list.noRelation') }}</b-card-body>
          <div v-if="view">
             <pagination
               :view="view"
               @getPage="getItems($event)"
             ></pagination>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <ShowRelationsModal
      @refetchRelations="fetchRelations()"
      v-if="relationIri !== null && canShowRelation"
      :showModal="isModalVisible"
      :iri="relationIri"
      @hideModal="hideModal"
    ></ShowRelationsModal>
  </b-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ShowRelationsModal from '@/components/Dashboard/Views/common/ShowRelationsModal'
import Loader from '@/components/Dashboard/Layout/Loader'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import { checkPermission, getUserRoles } from '@/utils/checkRoles.js'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'UpcomingRelations',
  components: {
    Loader,
    Pagination,
    ShowRelationsModal
  },
  computed: {
    ...mapGetters({
      created: 'excmrelation/create/created'
    }),
    canShowRelation () {
      return checkPermission('firms', 'EXCMRelationsShow')
    },
    canAddRelations () {
      return checkPermission('firms', 'EXCMRelationsCreate')
    },
    canSeeCases () {
      return checkPermission('cases', 'EXCMCaseShow')
    }
  },

  watch: {
    idUserData: {
      immediate: true,
      handler () {
        if ((this.idUserData || this.idUserData === null) || this.idCase || this.idFirm || this.idOrganizationLead) {
          this.addToParams(this.idUserData, this.idCase, this.idFirm, this.idOrganizationLead, this.searchParams)
          this.fetchRelations()
        }
      }
    },
    items: function () {
      if (this.items) {
        for (let i in this.items) {
          if (this.items[i].dateFrom) {
            this.items[i].dateFrom = this.$moment(this.items[i].dateFrom).format('YYYY-MM-DD HH:mm')
          }
        }
      }
    },
    created (val) {
      if (val) {
        this.fetchRelations()
        this.$emit('relationAdded')
      }
    }
  },
  props: {
    contactType: {
      type: Number,
      default () {
        return 1
      }
    },
    idFirm: {
      type: Number,
      required: false
    },
    idUserData: {
      required: false,
      default () {
        return getUserRoles().id_userdata
      }
    },
    idCase: {
      type: Number,
      required: false
    },
    idOrganizationLead: {
      type: Number,
      required: false
    }
  },

  data () {
    return {
      isModalVisible: false,
      relationIri: null,
      items: [],
      isLoading: null,
      view: {},
      searchParams: {
        state: 1,
        contactType: this.contactType,
        'dateTo[after]': this.$moment().format('YYYY-MM-DD HH:mm:ss')
      }
    }
  },
  created () {
    this.isLoading = true
  },

  methods: {
    getIdLink (link) {
      return getId(link)
    },
    fetchRelations () {
      this.getItems('e_x_c_m_relations', this.searchParams)
    },
    ...mapMutations({
      toggleMeetingModal: 'excmrelation/createModal/toggleMeetingModal',
      togglePhoneModal: 'excmrelation/createModal/togglePhoneModal'
    }),
    showCreateModal (val) {
      if (val === 2) {
        this.togglePhoneModal()
      }
      if (val === 1) {
        this.toggleMeetingModal()
      }
    },
    hideModal () {
      this.isModalVisible = false
      this.relationIri = null
    },
    showModal (iri) {
      this.relationIri = iri
      this.isModalVisible = !this.isModalVisible
    },
    setContentType () {
      this.$emit('setContactType', this.contactType)
    },
    addToParams (idUserData, idCase, idFirm, idOrganizationLead, searchParams) {
      if (idUserData || idUserData === null) {
        searchParams['relationUserData.userData'] = idUserData
      }
      if (idCase) {
        searchParams.idCase = idCase
      }
      if (idFirm) {
        searchParams.userData = idFirm
      }
      if (idOrganizationLead) {
        searchParams.idOrganizationLead = idOrganizationLead
      }
    },
    async getItems (route, params) {
      this.isLoading = true
      const response = await new ApiService(route, params).getResults()
      this.isLoading = false
      this.items = response.items
      this.view = response.view
    }
  }
}
</script>
